import {ResearchStateQuery} from '$src/bootstrap/Store'
import {Shape} from '$src/housingCorporations/TheMap'
import m from 'moment'

export default function queryComparableSales(
  {get}: any,
  regularQuery: typeof ResearchStateQuery.SnapshotType,
): Promise<any> {
  const serverQuery: any = {}

  if (regularQuery.mapShape) {
    const mapShape: Shape = regularQuery.mapShape
    if (mapShape.type === 'Polygon') {
      serverQuery.geoArea = {type: 'Polygon', vertices: mapShape.points}
    } else {
      serverQuery.geoArea = mapShape
    }
  }

  if (regularQuery.mapShapeRent) {
    const mapShapeRent: Shape = regularQuery.mapShapeRent
    if (mapShapeRent.type === 'Polygon') {
      serverQuery.geoAreaRent = {type: 'Polygon', vertices: mapShapeRent.points}
    } else {
      serverQuery.geoAreaRent = mapShapeRent
    }
  }

  const formValues = regularQuery.formValues.values

  const {dataType} = formValues
  if (dataType) {
    serverQuery.dataType = dataType
  }

  const {propertyType} = formValues
  if (Array.isArray(propertyType) && propertyType.length > 0) {
    serverQuery.propertyType = propertyType
  }

  const {propertyTypeRent} = formValues
  if (Array.isArray(propertyTypeRent) && propertyTypeRent.length > 0) {
    serverQuery.propertyTypeRent = propertyTypeRent
  }

  const {accommodationTypeRent} = formValues
  if (
    Array.isArray(accommodationTypeRent) &&
    accommodationTypeRent.length > 0
  ) {
    serverQuery.accommodationTypeRent = accommodationTypeRent
  }

  const {municipality} = formValues
  if (Array.isArray(municipality) && municipality.length > 0) {
    serverQuery.municipality = municipality
  }

  const {municipalityRent} = formValues
  if (Array.isArray(municipalityRent) && municipalityRent.length > 0) {
    serverQuery.municipalityRent = municipalityRent
  }

  const {postalCode} = formValues
  if (Array.isArray(postalCode) && postalCode.length > 0) {
    serverQuery.postalCode = postalCode
  }

  const {postalCodeRent} = formValues
  if (Array.isArray(postalCodeRent) && postalCodeRent.length > 0) {
    serverQuery.postalCodeRent = postalCodeRent
  }

  const {streetAddress} = formValues
  if (typeof streetAddress === 'string' && streetAddress.trim().length > 0) {
    serverQuery.streetAddress = streetAddress
  }

  const {streetAddressRent} = formValues
  if (
    typeof streetAddressRent === 'string' &&
    streetAddressRent.trim().length > 0
  ) {
    serverQuery.streetAddressRent = streetAddressRent
  }

  const {livingArea} = formValues
  if (livingArea) {
    let {from, to} = livingArea
    if (livingArea.from === '') {
      from = '0'
    }
    if (livingArea.to === '') {
      to = '99999999'
    }
    serverQuery.livingArea = {from, to}
  }

  const {livingAreaRent} = formValues
  if (livingAreaRent) {
    let {from, to} = livingAreaRent
    if (livingAreaRent.from === '') {
      from = '0'
    }
    if (livingAreaRent.to === '') {
      to = '99999999'
    }
    serverQuery.livingAreaRent = {from, to}
  }

  const {yearOfConstruction} = formValues
  if (yearOfConstruction) {
    let {from, to} = yearOfConstruction
    if (yearOfConstruction.from === '') {
      from = '0'
    }
    if (yearOfConstruction.to === '') {
      to = '99999999'
    }
    serverQuery.yearOfConstruction = {from, to}
  }

  const {yearOfConstructionRent} = formValues
  if (yearOfConstructionRent) {
    let {from, to} = yearOfConstructionRent
    if (yearOfConstructionRent.from === '') {
      from = '0'
    }
    if (yearOfConstructionRent.to === '') {
      to = '99999999'
    }
    serverQuery.yearOfConstructionRent = {from, to}
  }

  const {numberOfRooms} = formValues
  if (numberOfRooms) {
    let {from, to} = numberOfRooms
    if (numberOfRooms.from === '') {
      from = '0'
    }
    if (numberOfRooms.to === '') {
      to = '99999999'
    }
    serverQuery.numberOfRooms = {from, to}
  }

  const {numberOfRoomsRent} = formValues
  if (numberOfRoomsRent) {
    let {from, to} = numberOfRoomsRent
    if (numberOfRoomsRent.from === '') {
      from = '0'
    }
    if (numberOfRoomsRent.to === '') {
      to = '99999999'
    }
    serverQuery.numberOfRoomsRent = {from, to}
  }

  const {floorNumber} = formValues
  if (floorNumber) {
    let {from, to} = floorNumber
    if (floorNumber.from === '') {
      from = '0'
    }
    if (floorNumber.to === '') {
      to = '99999999'
    }
    serverQuery.floorNumber = {from, to}
  }

  const {floorNumberRent} = formValues
  if (floorNumberRent) {
    let {from, to} = floorNumberRent
    if (floorNumberRent.from === '') {
      from = '0'
    }
    if (floorNumberRent.to === '') {
      to = '99999999'
    }
    serverQuery.floorNumberRent = {from, to}
  }

  const {newlyBuilt} = formValues
  if (newlyBuilt === true || newlyBuilt === false) {
    serverQuery.newlyBuilt = newlyBuilt
  }

  const {condition} = formValues
  if (Array.isArray(condition) && condition.length > 0) {
    serverQuery.condition = condition
  }

  const {conditionRent} = formValues
  if (Array.isArray(conditionRent) && conditionRent.length > 0) {
    serverQuery.conditionRent = conditionRent
  }

  const {sellLength} = formValues
  if (sellLength) {
    let {from, to} = sellLength
    if (sellLength.from === '') {
      from = '0'
    }
    if (sellLength.to === '') {
      to = '99999999'
    }
    serverQuery.sellLength = {from, to}
  }

  const {dateOfSale} = formValues
  if (
    dateOfSale &&
    (typeof dateOfSale.startDate === 'number' ||
      typeof dateOfSale.endDate === 'number')
  ) {
    const from = m
      .unix(typeof dateOfSale.startDate === 'number' ? dateOfSale.startDate : 0)
      .format()

    const to = m
      .unix(
        typeof dateOfSale.endDate === 'number'
          ? dateOfSale.endDate
          : m.now() / 1000,
      )
      .format()

    serverQuery.dateOfSale = {from, to}
  }

  const {dateOfRent} = formValues
  if (
    dateOfRent &&
    (typeof dateOfRent.startDate === 'number' ||
      typeof dateOfRent.endDate === 'number')
  ) {
    const from = m
      .unix(typeof dateOfRent.startDate === 'number' ? dateOfRent.startDate : 0)
      .format()

    const to = m
      .unix(
        typeof dateOfRent.endDate === 'number'
          ? dateOfRent.endDate
          : m.now() / 1000,
      )
      .format()

    serverQuery.dateOfRent = {from, to}
  }

  const {plotOwned} = formValues
  if (plotOwned === true || plotOwned === false) {
    serverQuery.plotOwned = plotOwned
  }

  const {hasElevator} = formValues
  if (hasElevator === true || hasElevator === false) {
    serverQuery.hasElevator = hasElevator
  }

  const {hasSauna} = formValues
  if (hasSauna === true || hasSauna === false) {
    serverQuery.hasSauna = hasSauna
  }

  const {hasSaunaRent} = formValues
  if (hasSaunaRent === true || hasSaunaRent === false) {
    serverQuery.hasSaunaRent = hasSaunaRent
  }

  const {owner} = formValues
  if (Array.isArray(owner) && owner.length > 0) {
    serverQuery.owner = owner
  }

  const {source} = formValues
  if (Array.isArray(source) && source.length > 0) {
    serverQuery.source = source
  }

  return get(
    `/comparable-sales`,
    {query: JSON.stringify(serverQuery)},
    {retryOn401: true},
  )
}



// WEBPACK FOOTER //
// ./src/api/endpoints/comparableSales/query.tsx